module.exports = __webpack_public_path__ + "img/potential-center.ebd91b89.svg";